var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 62C48.1208 62 62 48.1208 62 31C62 13.8792 48.1208 0 31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62Z",
    fill: "#273B7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6001 42.8109L40.352 60.5627C51.456 57.0532 59.8575 47.4619 61.6459 35.697L44.0642 18.1152L22.6001 42.8109Z",
    fill: "#121149"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48.4387C43.4652 42.6856 43.9332 35.3466 44.0645 29.6212C44.1305 26.7454 44.0645 18.1149 44.0645 18.1149C35.5546 16.3171 31 13.5605 31 13.5605C31 13.5605 26.4454 16.3174 17.9356 18.1151C17.9356 18.1151 17.8696 26.7456 17.9356 29.6215C18.0668 35.3468 18.5349 42.6856 31 48.4387Z",
    fill: "#4486F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38.6152C35.7661 38.6152 39.6299 34.7515 39.6299 29.9853C39.6299 25.2192 35.7661 21.3555 31 21.3555C26.2338 21.3555 22.3701 25.2192 22.3701 29.9853C22.3701 34.7515 26.2338 38.6152 31 38.6152Z",
    fill: "#426FC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 30.3995C33.0356 30.3995 34.6857 28.7494 34.6857 26.7139C34.6857 24.6784 33.0356 23.0283 31.0001 23.0283C28.9646 23.0283 27.3145 24.6784 27.3145 26.7139C27.3145 28.7494 28.9646 30.3995 31.0001 30.3995Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 31.7939C28.1349 31.7939 25.5733 32.9653 23.8423 34.8077C25.3929 37.1046 28.0201 38.6152 30.9999 38.6152C33.9799 38.6152 36.607 37.1049 38.1575 34.8078C36.4265 32.9653 33.8649 31.7939 30.9999 31.7939Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.84f60477.svg";
export { ForwardRef as ReactComponent };